import { authHeader } from "../_helpers";

export const authRecovery = {
    reload: () => window.location.reload(),
};

/**
 * fetch wrapper for module API calls: attaches the stored Basic credentials
 * and forces re-login when the backend rejects them (same recovery as
 * user.service handleResponse)
 */
export const apiFetch = async (url, options = {}) => {
    const headers = { ...(options.headers || {}), ...authHeader() };
    const res = await fetch(url, { ...options, headers });
    if (res.status === 401) {
        localStorage.removeItem("user");
        authRecovery.reload();
    }
    return res;
};

const abortError = () => Object.assign(new Error("The request was aborted."), { name: "AbortError" });

/**
 * Shares one request between identical callers while keeping each caller's
 * AbortSignal independent. The transport is cancelled only after its final
 * consumer leaves.
 */
export const createMultiConsumerGet = (request) => {
    const inFlight = new Map();
    const settle = (key, entry, complete) => {
        if (inFlight.get(key) === entry) inFlight.delete(key);
        const consumers = [...entry.consumers];
        entry.consumers.clear();
        consumers.forEach((consumer) => {
            consumer.signal?.removeEventListener("abort", consumer.release);
            complete(consumer);
        });
    };

    return (key, options = {}) => {
        const result = new Promise((resolve, reject) => {
        let entry = inFlight.get(key);
        if (!entry) {
            const controller = new AbortController();
            entry = { controller, consumers: new Set() };
            inFlight.set(key, entry);
            Promise.resolve(request(key, { ...options, signal: controller.signal }))
                .then(
                    (value) => settle(key, entry, (consumer) => consumer.resolve(value)),
                    (error) => settle(key, entry, (consumer) => consumer.reject(error))
                );
        }

        let active = true;
        const consumer = { resolve, reject, signal: options.signal, release: null };
        entry.consumers.add(consumer);
        const release = () => {
            if (!active) return;
            active = false;
            entry.consumers.delete(consumer);
            options.signal?.removeEventListener("abort", release);
            queueMicrotask(() => reject(abortError()));
            if (entry.consumers.size === 0) {
                if (inFlight.get(key) === entry) inFlight.delete(key);
                entry.controller.abort();
            }
        };
        consumer.release = release;
        if (options.signal) {
            if (options.signal.aborted) release();
            else options.signal.addEventListener("abort", release, { once: true });
        }
        });
        result.catch(() => {});
        return result;
    };
};
